<div>
  <div class="prev-bar">
      <a (click)="back()" style="color: #0064c1" class="btn new-btn btn-secondary"><i class="fas fa-arrow-left"></i> {{ 'claimSection.generalLabels.generalButtonLabels.back' | translate}} </a>
  </div>
  <div class="col-12">
      <h5>{{ 'claimSection.generalLabels.whatHappened' | translate}}</h5>
      <p>{{ 'motorClaim.driverDetails.incidentAccidentDetails.heading' | translate }}</p>
   </div>
  <BR>
  <div class="row col-12">
    <div class="col-xl-9 col-lg-12">
        <form>
            <div class="form-group">
                <qnect-ui #MV_DD_DATETIME_ACCIDENT [fieldId]="'MV_DD_DATETIME_ACCIDENT'" [formGroup]="incidentAccidentForm" name="dateTime"></qnect-ui>
            </div>
            <div class="form-group">
              <qnect-ui #MV_DD_ACCIDENT_COUNTRY [fieldId]="'MV_DD_ACCIDENT_COUNTRY'" [formGroup]="incidentAccidentForm" name="country"></qnect-ui>
            </div>
            <div class="form-group">
              <qnect-ui #MV_DD_ACCIDENT_LOCATION_MAP [fieldId]="'MV_DD_ACCIDENT_LOCATION_MAP'" [formGroup]="incidentAccidentForm" name="location"></qnect-ui>
            </div>
            <div class="form-group">
              <qnect-ui #MV_DD_ACCIDENT_DESCRIPTION [fieldId]="'MV_DD_ACCIDENT_DESCRIPTION'" [formGroup]="incidentAccidentForm" name="accidentDescription"></qnect-ui>
            </div>
        </form>
    </div>
    <div class="col-xl-3 col-lg-12">
    </div>
  </div>

<div class="submit-bar">
    <abandon-button></abandon-button>
    <a href="javascript:;" (click)="showModal()" class="Tertiary">{{ 'claimSection.generalLabels.generalButtonLabels.save' | translate}}</a>
    <button (click)="goToNext()" class="btn new-btn btn-primary float-right"> {{ 'claimSection.generalLabels.generalButtonLabels.next' | translate}} <i class="fas fa-arrow-right" ></i></button>
</div>
<app-save-box [showTotalBox]="showTotalBox" (childEvent)="getData($event)"></app-save-box>
</div>